module.exports = __webpack_public_path__ + "img/3-3.bc35178d.jpg";